export default {
  userType: {
    phone: '手机号',
    shop_name: '店铺名',
    address: '地区',
  },
  shopType: {
    name: '店铺名',
    address: '地区',
  },
  giftType: {
    name: '礼品名称',
    shop_name: '店铺名',
  },
  actiType: {
    title: '活动名称',
    shop_name: '店铺名',
  },
  status: {
    0: '未开始',
    1: '进行中',
    2: '已结束',
  },
  status_c: {
    0: {color: '#c0c4cc', word: '未开始',},
    1: {color: '#96b471', word: '进行中',},
    2: {color: '#f56c6c', word: '已结束',},
  },
  giftSens: {
    1: '分享领好礼',
    2: '打卡领好礼',
    3: '下单领好礼',
  },
  actiSens: {
    1: '分享领好礼',
    2: '打卡领好礼',
    3: '下单领好礼',
  },
}
